import React from "react";
import { Button, Col, Layout, Row } from "antd";
import { useHistory } from "react-router-dom";

const { Header } = Layout;

export default function Navbar(props) {
  const history = useHistory();
  const { useButton } = props;
  return (
    <Header
      style={{
        backgroundColor: "#00a0ea",
        position: "fixed",
        zIndex: 1,
        width: "100%",
      }}
    >
      <Row justify="space-between">
        <Col span={17}>
          <img
            className="header_logo"
            alt="Carenting Logo"
            src={process.env.PUBLIC_URL + "/asset/logo.png"}
            style={{
              height: "50%",
            }}
          />
        </Col>
        {useButton ? (
          <Col span={7}>
            <Button
              className="button_secondary"
              style={{ marginRight: 12 }}
              onClick={() => {
                history.push("/register");
              }}
            >
              Register to be Psychologist
            </Button>
            <Button
              className="button_primary"
              onClick={() => {
                history.push("/login");
              }}
            >
              Sign In
            </Button>
          </Col>
        ) : null}
      </Row>
    </Header>
  );
}
